import React, { useState, useCallback, useEffect, useContext } from 'react';
import { GreetingCard } from './GreetingCard.jsx';
import { OccasionPicker } from './OccasionPicker.jsx';
import { ThemePicker } from './ThemePicker.jsx';
import { defaultTheme, themeList } from '../themes/index.js';
import { getOccasionDefaults, occasionDefaults_fr,occasionDefaults_ar,occasionDefaults_en,occasionDefaults_km } from '../utils/occasions.js';
import { AppContext } from '../../../AppContextProvider.jsx';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

const inp = { border: '0.5px solid #d1d5db', borderRadius: 8, padding: '8px 12px', fontSize: 14, fontFamily: 'inherit', outline: 'none', background: 'transparent', color: 'inherit', width: '100%', boxSizing: 'border-box' };
const lbl = { fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.55 };
const sec = { fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', opacity: 0.5, marginBottom: 10, marginTop: 20 };

export function CardEditor({ close=()=>{},initialContent = {}, initialTheme = defaultTheme, onChange, onExport, showOccasionPicker = true, showThemePicker = true, showExportButton = false, className = '' }) {
  const [occasion, setOccasionState] = useState(initialContent.occasion);
  const [theme, setTheme] = useState(initialTheme);
  const {t} = useTranslation();

  const [AppState,SetAppState] = useContext(AppContext);
  const [content, setContent] = useState({
    ...initialContent,
  });

  useEffect(()=>{
    var default_occasion = occasionDefaults_fr;
    if (AppState.settings.lang==='ar')
    {default_occasion=occasionDefaults_ar}
    else if(AppState.settings.lang==='en')
      default_occasion = occasionDefaults_en;
    else if(AppState.settings.lang==='km' || AppState.settings.lang==='sw')
      default_occasion = occasionDefaults_km;

    setContent({
        ...initialContent,
      });
  },[,AppState.settings.lang])

  const updateContent = useCallback((patch) => {
    setContent((prev) => {
      const next = { ...prev, ...patch };
      onChange?.(next, theme);
      return next;
    });
  }, [theme, onChange]);

  const handleOccasion = (occ) => {
    const def = getOccasionDefaults(occ,AppState.settings.lang);
    setOccasionState(occ);
    const suggested = themeList.find((t) => t.id === def.suggestedTheme) ?? theme;
    setTheme(suggested);
    updateContent({ occasion: occ, title: def.title, message: def.message });
  };

  const handleTheme = (t) => {
    setTheme(t);
    onChange?.(content, t);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, fontFamily: "'Lato', sans-serif" }} className={className}>
      <div style={{position:'relative',margin:'auto',width:'100%'}}>
          <label onClick={()=>{close()}} style={{position:'absolute',top:'10px',right:'10px',backgroundColor:'orangered',padding:'3px 10px',borderRadius:'3px',color:'white'}}>{t('cadeau.annuler')}</label>
          <GreetingCard showControl={false} content={content} theme={theme} size={isMobile?"sm":"md"} showDate />
      </div>
      <div style={{margin:'auto',textAlign:'center',background: '#fff', border: '0.5px solid #e5e7eb', borderRadius: 12, padding: '1.25rem 1.5rem' }}>
        {showOccasionPicker && (
          <div style={{marginTop:'10px'}}>
            <p style={sec}>{t('cadeau.occasion')}</p>
            <OccasionPicker value={occasion} onChange={handleOccasion} />
          </div>
        )}

        {showThemePicker && (
          <div style={{marginTop:'10px'}}>
            <p style={sec}>{t('cadeau.theme')}</p>
            <ThemePicker value={theme} themes={themeList} onChange={handleTheme} />
          </div>
        )}

        {/*<p style={sec}>Contenu</p>*/}

        <div style={{marginTop:'10px',display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
          <label style={lbl}>{t('cadeau.titre')}</label>
          <input style={inp} type="text" value={content.title ?? ''} placeholder="Titre…" onChange={(e) => updateContent({ title: e.target.value })} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
          <label style={lbl}>{t('cadeau.message')}</label>
          <textarea style={{ ...inp, resize: 'vertical', minHeight: 80, lineHeight: 1.6 }} value={content.message} placeholder="Votre message…" onChange={(e) => updateContent({ message: e.target.value })} />
        </div>

        <div style={{ display:'flex',flexDirection:'row', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6,width:'15%' }}>
            <label style={lbl}>{t('cadeau.anonymous')}</label>
            <input style={{...inp,width:'30px',height:'30px',margin:'auto'}} type="checkbox" onChange={(e) => updateContent({ is_anonymous: e.target.checked })} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6,width:'35%' }}>
            <label style={lbl}>{t('cadeau.de')}</label>
            <input style={inp} type="text" value={content.from ?? ''} placeholder={t("")} onChange={(e) => updateContent({ from: e.target.value })} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6,width:'35%' }}>
            <label style={lbl}>{t('cadeau.destinataire')}</label>
            <input style={inp}  type="text" value={content.to ?? ''} placeholder={t("authentication.email")} onChange={(e) => updateContent({ to: e.target.value })} />
          </div>
        </div>
        {showExportButton && (
          
          <div style={{display:'flex',flexDirection:'row',width:'100%',marginTop:'20px'}}>
            <button type="button" style={{ width: '40%',margin:'auto', padding: 11, borderRadius: 8, background: '#1a1a2e', color: '#e8e0f0', fontFamily: 'inherit', fontSize: 13, border: 'none', cursor: 'pointer', marginTop: 16 }} onClick={() => onExport?.('export')}>
                {t('cadeau.partager')}
            </button>
            <button type="button" style={{ width: '40%',margin:'auto', padding: 11, borderRadius: 8, background: '#de5d3a', color: '#e8e0f0', fontFamily: 'inherit', fontSize: 13, border: 'none', cursor: 'pointer', marginTop: 16 }} onClick={() => close?.()}>
              {t('cadeau.annuler')}
          </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CardEditor;
